var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20,2h-5v-1c0-.55-.45-1-1-1s-1,.45-1,1v1h-5v-1c0-.55-.45-1-1-1s-1,.45-1,1v1h-3c-.8,0-1.56.32-2.12.88-.56.56-.88,1.32-.88,2.12v20c0,.8.32,1.56.88,2.12.56.56,1.32.88,2.12.88h22c.8,0,1.56-.32,2.12-.88.56-.56.88-1.32.88-2.12V5c0-.8-.32-1.56-.88-2.12-.56-.56-1.32-.88-2.12-.88h-3v-1c0-.55-.45-1-1-1s-1,.45-1,1v1Zm6,9v14c0,.26-.1.52-.29.71-.19.19-.44.29-.71.29H3c-.26,0-.52-.1-.71-.29-.19-.19-.29-.44-.29-.71v-14h24Zm-4-7v1.19c0,.55-.45,1-1,1s-1-.45-1-1v-1.19h-5v1.19c0,.55-.45,1-1,1s-1-.45-1-1v-1.19h-5v1.19c0,.55-.45,1-1,1s-1-.45-1-1v-1.19h-3c-.26,0-.52.1-.71.29-.19.19-.29.44-.29.71v4h24v-4c0-.26-.1-.52-.29-.71-.19-.19-.44-.29-.71-.29h-3Z",
    fillRule: "evenodd",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.7867c802a156a56d793b407fc2628ba9.svg";
export { ForwardRef as ReactComponent };